"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceableEndpoint = void 0;
class ReplaceableEndpoint {
    constructor(config) {
        this.config = config;
    }
    create(...args) {
        const [endpointKey, params, queryParams] = args;
        const paramValues = params;
        const pathname = this.config.endpoints[endpointKey];
        const pathnameWithParams = paramValues ? this.generatePath(pathname, paramValues) : pathname;
        const pathnameWithQueryParams = this.applyQueryParams(pathnameWithParams, queryParams);
        return this.replaceWildcards(pathnameWithQueryParams);
    }
    getWildcardsMap() {
        return {
            '<HOST>': this.config.globalConfig.global_config_host,
            '<PREFIX>': this.config.globalConfig.global_config_prefix,
        };
    }
    generatePath(pathname, paramValues) {
        return Object.entries(paramValues).reduce((acc, [param, value]) => acc.replace(`:${param}`, value), pathname);
    }
    replaceWildcards(pathname) {
        return Object.entries(this.getWildcardsMap()).reduce((acc, [wildcard, value]) => acc.replace(wildcard, value), pathname);
    }
    applyQueryParams(pathname, queryParams = {}) {
        if (Object.keys(queryParams).length === 0) {
            return pathname;
        }
        const concatSymbol = pathname.includes('?') ? '&' : '?';
        const queryParamsString = Object.entries(queryParams)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        return `${pathname}${concatSymbol}${queryParamsString}`;
    }
}
exports.ReplaceableEndpoint = ReplaceableEndpoint;
//# sourceMappingURL=ReplaceableEndpoint.js.map